(() => {
  const configNode = document.querySelector('[data-sanam-browsing-context]');
  if (!configNode || customElements.get('sanam-empty-recommendations')) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const key = 'sanam_empty_cart_context_v1';
  const ttl = 30 * 24 * 60 * 60 * 1000;
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,180}$/.test(value);
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const includesWords = (text, words) => (' ' + normalize(text) + ' ').includes(' ' + normalize(words) + ' ');
  const category = title => {
    const text = normalize(title);
    if (/photocard|polaroid/.test(text)) return 'photocards';
    if (/librito|colorear|pintar/.test(text)) return 'libritos';
    if (/peluche|skzoo|lovely/.test(text)) return 'peluches';
    if (/sticker|figurita/.test(text)) return 'stickers';
    if (/sleeve|holder|toploader|folio|binder/.test(text)) return 'accesorios';
    if (/album|digipack/.test(text)) return 'albumes';
    if (/poster/.test(text)) return 'posters';
    if (/llavero/.test(text)) return 'llaveros';
    if (/kit/.test(text)) return 'kits';
    return '';
  };
  const root = new URL(config.root || '/', location.origin).pathname.replace(/\/?$/, '/');
  const groups = window.SanamSearchCatalog?.groups || [];
  const generic = new Set(['all', 'frontpage', 'ofertas', 'nuevos-ingresos', 'albumes-en-camino', 'entrega-inmediata-todos-los-productos', 'albumes-entrega-inmediata']);
  let context = null;
  try {
    const saved = JSON.parse(localStorage.getItem(key) || 'null');
    if (saved && Date.now() - saved.time < ttl && validHandle(saved.source?.handle)) context = saved;
    else localStorage.removeItem(key);
  } catch {}
  const product = config.product;
  const collection = config.collection;
  if (product) {
    const collections = (product.collections || []).filter(item => validHandle(item.handle) && !generic.has(item.handle));
    const group = groups.find(item => (item.aliases || [item.name]).some(alias => includesWords(product.title, alias)));
    const groupSource = collections.find(item => group?.handle === item.handle) ||
      collections.find(item => item.handle.endsWith('-todos-los-productos'));
    const typeSource = collections.find(item => /photocard|librito|accesorio|personalizado|peluche|sticker|poster|llavero|album/i.test(item.handle));
    const source = groupSource || typeSource;
    if (source) context = { source, type: product.type || '', category: category(product.title), productId: product.id, group: Boolean(groupSource), time: Date.now() };
    else context = null;
  } else if (collection && validHandle(collection.handle) && !generic.has(collection.handle)) {
    context = { source: collection, type: '', productId: null, group: collection.handle.endsWith('-todos-los-productos'), time: Date.now() };
  }
  try {
    if (context) localStorage.setItem(key, JSON.stringify(context));
    else if (product) localStorage.removeItem(key);
  } catch {}
  let candidatesPromise;
  const getCandidates = () => {
    if (!candidatesPromise) candidatesPromise = (async () => {
      if (!context || !validHandle(context.source?.handle)) return [];
      const url = root + 'collections/' + encodeURIComponent(context.source.handle) + '/products.json?limit=100';
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return [];
      const data = await response.json();
      const seen = new Set();
      const available = (data.products || []).filter(item => {
        if (!validHandle(item.handle) || seen.has(item.id) || String(item.id) === String(context.productId)) return false;
        seen.add(item.id);
        return (item.variants || []).some(variant => variant.available && Number(variant.price) > 0);
      });
      const exactType = item => context.category ? category(item.title) === context.category : Boolean(context.type) && normalize(item.product_type) === normalize(context.type);
      const filtered = (context.type || context.category) && !context.group ? available.filter(exactType) : available;
      return filtered.sort((a, b) => Number(exactType(b)) - Number(exactType(a))).slice(0, 4);
    })().catch(() => []);
    return candidatesPromise;
  };
  class EmptyRecommendations extends HTMLElement {
    async connectedCallback() {
      this.hidden = true;
      if (this.dataset.ready || !context) return;
      this.dataset.ready = 'true';
      const candidates = await getCandidates();
      if (!this.isConnected || !candidates.length) return;
      const grid = this.querySelector('.sanam-empty-grid');
      if (!grid) return;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'es-UY', { style: 'currency', currency: config.currency || 'UYU', currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 });
      const fragment = document.createDocumentFragment();
      for (const product of candidates) {
        const variants = product.variants.filter(item => item.available && Number(item.price) > 0);
        const card = document.createElement('a');
        card.className = 'sanam-empty-card';
        card.href = root + 'products/' + product.handle;
        const source = product.images?.[0]?.src;
        if (source) {
          try {
            const imageUrl = new URL(source, location.origin);
            if (imageUrl.protocol === 'https:' && (imageUrl.hostname === location.hostname || imageUrl.hostname === 'cdn.shopify.com')) {
              imageUrl.searchParams.set('width', '360');
              const image = document.createElement('img');
              image.src = imageUrl.href;
              image.alt = product.title;
              image.loading = 'lazy';
              image.width = 360;
              image.height = 360;
              card.append(image);
            }
          } catch {}
        }
        const title = document.createElement('strong');
        title.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'sanam-empty-price';
        const prices = variants.map(item => Number(item.price));
        price.textContent = (Math.max(...prices) > Math.min(...prices) ? this.dataset.from + ' ' : '') + formatter.format(Math.min(...prices)) + ' UYU';
        const options = document.createElement('span');
        options.className = 'sanam-empty-options';
        options.textContent = this.dataset.options;
        card.append(title, price, options);
        fragment.append(card);
      }
      grid.replaceChildren(fragment);
      this.querySelector('h2').textContent = this.dataset.heading;
      this.querySelector('.sanam-empty-caption').textContent = this.dataset.caption;
      const more = this.querySelector('.sanam-empty-more');
      more.textContent = this.dataset.more + ' · ' + context.source.title;
      more.href = root + 'collections/' + context.source.handle;
      this.hidden = false;
    }
  }
  customElements.define('sanam-empty-recommendations', EmptyRecommendations);
})();
